import { getPropertiesQuietly, getRecommendationV2ById } from "../api";
import { RECOMMENDATION_QUERY_PARAM } from "../constants/recommendationDeepLink";

/**
 * The property an email deep link's recommendationId belongs to, looked up
 * before the app picks its first property (EO-1893) — so the header opens on
 * that hotel rather than flashing the default and reloading onto it.
 *
 * Resolved through the user's own property search (by the portal property
 * code), which is the access boundary. Both calls skip the shared error toast;
 * any failure returns null and leaves the page-level hook
 * (useRecommendationDeepLink) to switch or show Unauthorized.
 *
 * @param {string} search location.search to read the link from
 * @returns {Promise<Object|null>} the property object, or null
 */
const resolveLinkedProperty = async (search) => {
  const recommendationId = new URLSearchParams(search).get(
    RECOMMENDATION_QUERY_PARAM
  );
  if (!recommendationId) return null;
  try {
    const lookup = await getRecommendationV2ById(recommendationId);
    const { propertyId, propertyCode } = lookup?.data?.data || {};
    if (!propertyId || !propertyCode) return null;
    const res = await getPropertiesQuietly({
      searchText: propertyCode,
      page: 1,
      limit: 100,
    });
    return (
      (res?.data?.data?.properties || []).find(
        (property) => String(property?.propertyId) === String(propertyId)
      ) ?? null
    );
  } catch {
    return null;
  }
};

export default resolveLinkedProperty;
